import { tv } from 'tailwind-variants'

import { caption } from '@ui-kit/core/typography'

export const inlineNotification = tv({
  slots: {
    container: 'flex flex-row items-center gap-x-1',
    text: caption(),
    svg: '',
  },
  variants: {
    type: {
      error: {
        container: 'text-error',
        text: 'text-error',
        svg: 'fill-error',
      },
      success: {
        container: 'text-success',
        text: 'text-success',
        svg: 'fill-success',
      },
      warning: {
        container: 'text-warning',
        text: 'text-warning',
        svg: 'fill-warning',
      },
    },
  },
})
